module.exports = __webpack_public_path__ + "assets/images/project/close.svg?v=f720a7d2";